import React from 'react'
import { Row, Col, Typography, Layout } from 'antd';
import { SidebarNavigation } from '../../../components/Dashboard/account/SidebarNavigation/SidebarNavigation.component';
import { ChangePasswordForm } from '../../../components/Dashboard/account/ChangePasswordForm.component';
import { EditInformationForm } from '../../../components/Dashboard/account/EditInformationForm.component';
import { AccountSettings } from '../../../components/Dashboard/account/AccountSettings.component';
import { useApp } from '../../../context/app-context';
import { UserCard } from '../../../components/Dashboard/account/UserCard/UserCard.component';
import './AccountScreen.css';
import { Screen } from '../../../components/UI/Screen.component';

const { Content } = Layout; 
const { Title } = Typography;

export const AccountScreen = ({account, ...props}) => {

    const { state: {user}} = useApp();

    return (
        <>
            <Screen id='account-screen'>
                <div className="account-screen" style={{minHeight: '100vh'}}>
                    <div className="account__sidebar">
                        <Col style={{ marginTop: "50px", marginBottom: "20px" }}>
                            {account && <UserCard account={user}/> }
                            {/* <SidebarNavigation description="admin"/> */}
                        </Col>
                    </div>
                    <Content className="account__content">
                        <Row align="center">
                            <Col xs={20} sm={20} md={16} lg={16} xl={16}>
                                <Title>Account Information</Title>
                                {account && <EditInformationForm account={account} isAdmin={false}/>}
                                {/* <AccountSettings/> */}
                                <ChangePasswordForm account={account}/>
                            </Col>
                        </Row>
                    </Content>
                </div>
            </Screen>
        </>
    );
};

